export const AUTH_ROLE_EMAIL_VERIFIED = 'email_verified';
export const AUTH_ROLE_NOT_VERIFIED = 'not_verified';
export const AUTH_ROLE_PHONE_VERIFIED = 'phone_verified';
export const AUTH_ROLE_ID_VERIFIED = 'id_verified';
export const ROLE_ADMIN = 'admin';
export const ROLE_USER = 'user';
export const ROLE_SUPPLIER = 'supplier';
